/* v15 — Full-screen pre-checkout Mystery Box offer (one per family).
   Only two choices: skip or unlock. The countdown is real: once it ends or the
   buyer skips, the offer is not shown again in this browsing session. */
(() => {
  const source = document.getElementById('dm-mastery-config');
  if (!source) return;
  const config = JSON.parse(source.textContent);
  const shared = config.shared || {};
  const STATE_KEY = 'dm-mastery-v15';
  const HOLD_MS = 10 * 60 * 1000;
  const CHECKOUT_SELECTOR = ['.dm-vault-checkout-button', '.ocu-checkout-button', 'button[name="checkout"]', 'input[name="checkout"]', 'a[href="/checkout"]', 'a[href$="/checkout"]'].join(',');
  const root = () => window.Shopify?.routes?.root || '/';
  // Liquid's t filter HTML-escapes copy; decode once so escape() below is the only escaping.
  const decode = value => value.replace(/&(amp|lt|gt|quot|#39|#x27|apos);/g, (m, e) => ({amp:'&',lt:'<',gt:'>',quot:'"','#39':"'",'#x27':"'",apos:"'"}[e]));
  const clean = value => (typeof value === 'string' && !/^translation missing/i.test(value.trim()) ? decode(value) : '');
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = cents => new Intl.NumberFormat('en-US', {style:'currency', currency: config.currency || 'USD'}).format(cents / 100);
  const readState = () => { try { return JSON.parse(sessionStorage.getItem(STATE_KEY) || '{}'); } catch (_) { return {}; } };
  const writeState = state => { try { sessionStorage.setItem(STATE_KEY, JSON.stringify(state)); } catch (_) {} };
  const idOf = item => Number(item.variant_id || item.id);

  // Which offer (if any) this cart qualifies for. Mixed carts get none: each box
  // contains the other family's content, which a mixed cart already has.
  function qualifies(cart, state = readState(), now = Date.now()) {
    const ids = new Set((cart?.items || []).map(idOf));
    const life = ids.has(config.mains.life), phonics = ids.has(config.mains.phonics);
    if (life === phonics) return null;
    const family = life ? 'life' : 'phonics';
    const offer = config.offers?.[family];
    if (!offer?.variant || !offer.available || ids.has(Number(offer.variant))) return null;
    const own = state[family];
    if (own && (own.done || (own.end && own.end <= now))) return null;
    return family;
  }

  async function readCart() {
    const response = await fetch(`${root()}cart.js`, {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}});
    if (!response.ok) throw new Error(`Cart request failed (${response.status})`);
    return response.json();
  }
  const goToCheckout = () => window.location.assign(`${root()}checkout`);

  let modal, family, timer, previousFocus, intercepting = false;

  function markDone(name) { const state = readState(); state[name] = {...(state[name] || {}), done: true}; writeState(state); }

  function render(name) {
    const offer = config.offers[name];
    const copy = offer.copy || {};
    const items = ['item1', 'item2', 'item3', 'item4', 'item5'].map(key => clean(copy[key])).filter(Boolean);
    const compare = Number(offer.compare) > Number(offer.cents) ? Number(offer.compare) : 0;
    const ribbon = clean(copy.ribbon);
    return `
      <div class="dm-mo__head">
        <h2 id="dm-mo-title">${escape(clean(copy.headline))}</h2>
        ${clean(copy.subline) ? `<p>${escape(clean(copy.subline))}</p>` : ''}
      </div>
      <div class="dm-mo__timer" role="timer" aria-live="off"><span>${escape(clean(shared.timer))}</span> <b data-dm-mo-timer>10:00</b></div>
      <div class="dm-mo__body">
        <figure class="dm-mo__media"><img src="${escape(offer.image)}" width="${Number(offer.imageWidth) || 1100}" height="${Number(offer.imageHeight) || 1100}" alt="${escape(clean(copy.image_alt))}" decoding="async"></figure>
        <div class="dm-mo__info">
          ${ribbon ? `<span class="dm-mo__ribbon">${escape(ribbon)}</span>` : ''}
          <h3>${escape(clean(copy.title))}</h3>
          <p class="dm-mo__label">${escape(clean(shared.inside))}</p>
          <ul class="dm-mo__list" role="list">${items.map(item => `<li>${escape(item)}</li>`).join('')}</ul>
          ${clean(copy.fact) ? `<p class="dm-mo__fact"><span aria-hidden="true">⭐</span> ${escape(clean(copy.fact))}</p>` : ''}
          <div class="dm-mo__price">${compare ? `<s>${money(compare)}</s>` : ''}<strong>${money(offer.cents)}</strong></div>
          ${compare ? `<p class="dm-mo__save">${escape(clean(shared.save))} ${money(compare - offer.cents)}</p>` : ''}
          <p class="dm-mo__digital">${escape(clean(shared.digital))}</p>
          <p class="dm-mo__status" role="status" data-dm-mo-status></p>
        </div>
      </div>
      <div class="dm-mo__actions">
        <button type="button" class="dm-mo__no" data-dm-mo-decline>${escape(clean(shared.decline))}</button>
        <button type="button" class="dm-mo__yes" data-dm-mo-accept>${escape(clean(shared.accept))}</button>
      </div>`;
  }

  function tick(end) {
    const output = modal?.querySelector('[data-dm-mo-timer]');
    if (!output) return;
    const remaining = Math.max(0, end - Date.now());
    output.textContent = `${String(Math.floor(remaining / 60000)).padStart(2, '0')}:${String(Math.floor((remaining % 60000) / 1000)).padStart(2, '0')}`;
    if (remaining === 0) expire();
  }

  function expire() {
    clearInterval(timer);
    const accept = modal.querySelector('[data-dm-mo-accept]');
    accept.disabled = true;
    accept.textContent = clean(shared.expired);
    modal.querySelector('[data-dm-mo-decline]').textContent = clean(shared.continue);
    markDone(family);
  }

  function open(name) {
    family = name;
    const state = readState();
    if (!state[name]?.end) { state[name] = {end: Date.now() + HOLD_MS}; writeState(state); }
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'dm-mo';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', 'dm-mo-title');
      document.body.appendChild(modal);
      modal.addEventListener('click', event => {
        if (event.target.closest('[data-dm-mo-decline]')) decline();
        else if (event.target.closest('[data-dm-mo-accept]')) accept();
      });
    }
    // Same max z-index as the OCU drawer: stay last in the DOM so the offer wins.
    if (modal !== document.body.lastElementChild) document.body.appendChild(modal);
    modal.dataset.family = name;
    modal.innerHTML = render(name);
    previousFocus = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add('dm-mastery-open');
    const end = readState()[name].end;
    clearInterval(timer);
    tick(end);
    timer = setInterval(() => tick(end), 1000);
    requestAnimationFrame(() => modal.querySelector('[data-dm-mo-accept]:not([disabled])')?.focus({preventScroll: true}));
  }

  function close() {
    clearInterval(timer);
    if (modal) modal.hidden = true;
    document.documentElement.classList.remove('dm-mastery-open');
    previousFocus?.focus?.({preventScroll: true});
  }

  function decline() { markDone(family); close(); goToCheckout(); }

  async function accept() {
    const button = modal.querySelector('[data-dm-mo-accept]');
    const status = modal.querySelector('[data-dm-mo-status]');
    const offer = config.offers[family];
    button.disabled = true;
    button.textContent = clean(shared.adding);
    status.textContent = '';
    try {
      const cart = await readCart();
      if (!cart.items.some(item => idOf(item) === Number(offer.variant))) {
        const response = await fetch(`${root()}cart/add.js`, {method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: [{id: Number(offer.variant), quantity: 1, properties: {_dm_mystery_offer: 'Full-screen checkout offer'}}]})});
        if (!response.ok) throw new Error(`Add failed (${response.status})`);
      }
      markDone(family);
      goToCheckout();
    } catch (error) {
      console.warn('[Peppo Kids] Mystery Box could not be added.', error);
      status.textContent = clean(shared.error);
      button.disabled = false;
      button.textContent = clean(shared.accept);
    }
  }

  // OCU checkout buttons are replaced so the app cannot navigate before the offer.
  function ownOcuCheckoutButtons(scope = document) {
    scope.querySelectorAll('.ocu-checkout-button').forEach(nativeButton => {
      if (nativeButton.dataset.dmVaultReplaced === 'true') return;
      const button = nativeButton.cloneNode(true);
      button.classList.remove('ocu-checkout-button');
      button.classList.add('dm-vault-checkout-button');
      button.dataset.dmVaultReplaced = 'true';
      button.type = 'button';
      button.removeAttribute('name');
      button.removeAttribute('disabled');
      nativeButton.replaceWith(button);
    });
  }

  async function intercept(event) {
    if (intercepting || (modal && !modal.hidden)) { event.preventDefault(); return; }
    intercepting = true;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation?.();
    try {
      const name = qualifies(await readCart());
      if (name) open(name); else goToCheckout();
    } catch (error) {
      console.warn('[Peppo Kids] Checkout qualification failed.', error);
      goToCheckout();
    } finally { intercepting = false; }
  }

  document.addEventListener('click', event => {
    const trigger = event.target.closest?.(CHECKOUT_SELECTOR);
    if (!trigger || trigger.closest('.dm-mo')) return;
    intercept(event);
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.matches(CHECKOUT_SELECTOR)) intercept(event);
  }, true);
  document.addEventListener('keydown', event => {
    if (!modal || modal.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); decline(); return; }
    if (event.key !== 'Tab') return;
    const buttons = [...modal.querySelectorAll('button:not([disabled])')];
    if (!buttons.length) return;
    if (event.shiftKey && document.activeElement === buttons[0]) { event.preventDefault(); buttons.at(-1).focus(); }
    else if (!event.shiftKey && document.activeElement === buttons.at(-1)) { event.preventDefault(); buttons[0].focus(); }
  });
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (node.matches?.('.ocu-checkout-button')) ownOcuCheckoutButtons(node.parentElement || document);
      else if (node.querySelector?.('.ocu-checkout-button')) ownOcuCheckoutButtons(node);
    }
  }).observe(document.documentElement, {childList: true, subtree: true});
  ownOcuCheckoutButtons();

  const preload = () => typeof Image === 'function' && Object.values(config.offers).forEach(offer => { const image = new Image(); image.decoding = 'async'; image.src = offer.image; });
  if (window.requestIdleCallback) requestIdleCallback(preload, {timeout: 4000}); else setTimeout(preload, 2000);

  window.DMMastery = {qualifies, open};
})();
